export { SkyTextHighlightModule } from './text-highlight.module';
export { SkyTextHighlightDirective } from './text-highlight.directive';
